import { Dispatch, SetStateAction } from 'react';
import { useDropzone } from 'react-dropzone';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { getFileBadge } from 'components/UploadHub/fileTypeBadges';

interface UploadHubFileDropzoneProps {
  pendingFiles: File[];
  setPendingFiles: Dispatch<SetStateAction<File[]>>;
}

const UploadHubFileDropzone = ({ pendingFiles, setPendingFiles }: UploadHubFileDropzoneProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles, fileRejections) => {
      setPendingFiles((current) => current.concat(acceptedFiles));
      fileRejections.forEach(({ file, errors }) => {
        createNotification('danger', `${file.name}: ${errors[0]?.message ?? 'File could not be added'}`);
      });
    },
  });

  const removePendingFile = (index: number) => {
    setPendingFiles((current) => current.filter((_, i) => i !== index));
  };

  return (
    <>
      <div
        {...getRootProps({
          className: `rounded box-rounded-dashed general-dropzone d-flex justify-content-center align-items-center mb-3 ${isDragActive ? 'active-dropzone' : ''}`,
        })}
      >
        <input {...getInputProps()} />
        <p className='text-center mb-0'>
          {isDragActive ? (
            'Drop your files here'
          ) : (
            <>
              + Drag and drop or <span className='simple-link-button text-underline'>upload a file</span>
            </>
          )}
        </p>
      </div>

      {pendingFiles.length > 0 && (
        <ul className='policy-list px-0 mb-3'>
          {pendingFiles.map((file, index) => {
            const badge = getFileBadge(file.name);
            return (
              <li
                className='border-main-blue-50 box-rounded d-flex justify-content-between mb-3 align-items-center'
                key={`${file.name}-${index}`}
              >
                <div className='d-flex align-items-center'>
                  <p className='attachment-name mb-0 flex-centered'>
                    <span
                      className={`mr-2 font-weight-bold upload-hub-file-icon upload-hub-file-icon-sm ${badge.className} text-white text-center flex-centered justify-content-center`}
                    >
                      {badge.label}
                    </span>
                    {file.name}
                  </p>
                </div>
                <div className='px-3'>
                  <button
                    className='general-button topic-alert-delete'
                    data-tooltip-id='general-tooltip'
                    data-tooltip-content='Remove'
                    onClick={() => removePendingFile(index)}
                  ></button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default UploadHubFileDropzone;
